/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutocompleteAddressChoice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AutocompleteAddressChoice({
  children,
  viewPath = "/DesignSystem/AutocompleteAddressChoice",
  onClick,
  isSelected,
  description = ""
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="AutocompleteAddressChoice.AutocompleteAddressChoice:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-1ATj9p': isSelected ? "#f2f2f2" : isHovered ? "rgba(255,131,0, 0.2)" : "#ffffff"}}
 className={`views-block ${styles.AutocompleteAddressChoice1}`}
>
<span
  data-testid="AutocompleteAddressChoice.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{description}
</span>
</button>
{children}
</React.Fragment>)
}